module.exports = __webpack_public_path__ + "img/d4.aebabe04.webp";